import React from 'react';

export interface JobSwitchingMenuState {
  [x:string]:any
}

interface IJobSwitchingMenuContext {
  context: JobSwitchingMenuState,
  setInContext: (key: string, value: any) => void,
  resetForCurrentJob: VoidFunction,
  isHome: boolean,
  hasSideMenu: boolean,
};

const defaultState:IJobSwitchingMenuContext = {
  context: {},
  setInContext: () => {},
  resetForCurrentJob: () => {},
  isHome: false,
  hasSideMenu: false,
};

/**
 * Job Menu context which value is reset to defaults every time job looses focus, unlike fast storage which preserves state
 */
const JobSwitchingMenuContext = React.createContext<IJobSwitchingMenuContext>(defaultState);

export default JobSwitchingMenuContext;
